module.exports = __webpack_public_path__ + "img/Ravital Solomon.01004fac.jpg";